var _excluded = ["children", "className", "component", "wrapClassName"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef, useContext, useRef, useState } from "react";
import AAppContext from "../AApp/AAppContext";
import { AToastPlate } from "../AToaster";
import { useCombinedRefs } from "../../utils/hooks";
var AMount = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    propsClassName = _ref.className,
    component = _ref.component,
    propsWrapClassName = _ref.wrapClassName,
    rest = _objectWithoutProperties(_ref, _excluded);
  var newWrapRef = useRef(null);
  var newAppRef = useRef(null);
  var combinedRef = useCombinedRefs(ref, newAppRef);
  var _useContext = useContext(AAppContext),
    toasts = _useContext.toasts,
    setToasts = _useContext.setToasts;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    toasts2 = _useState2[0],
    setToasts2 = _useState2[1];
  var className = "a-mount";
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  var wrapClassName = "a-mount--wrap";
  if (propsWrapClassName) {
    wrapClassName += " ".concat(propsWrapClassName);
  }
  var TagName = component || "div";
  var appContext = {
    appRef: combinedRef,
    wrapRef: newWrapRef,
    toasts: toasts || toasts2,
    setToasts: setToasts || setToasts2
  };
  var hasToastPlate = combinedRef.current && combinedRef.current.classList.contains("a-app");
  return /*#__PURE__*/React.createElement(TagName, _extends({}, rest, {
    ref: combinedRef,
    className: className
  }), /*#__PURE__*/React.createElement(AAppContext.Provider, {
    value: appContext
  }, /*#__PURE__*/React.createElement("div", {
    ref: newWrapRef,
    className: wrapClassName
  }, children), hasToastPlate && /*#__PURE__*/React.createElement(AToastPlate, null)));
});
AMount.propTypes = {
  /**
   * Sets the base component.
   */
  component: PropTypes.elementType,
  /**
   * Sets the class name for the wrapper container.
   */
  wrapClassName: PropTypes.string
};
AMount.displayName = "AMount";
export default AMount;